window.global ||= window